import { instance } from './index'

// 获取文章评论列表
export function getComments(articleId) {
  return instance.get(`/comments/${articleId}`)
}

// 添加评论
export function addComment(data) {
  return instance.post('/comments', data)
}

// 回复评论
export function replyComment(commentId, data) {
  if (!commentId) {
    return Promise.reject(new Error('评论ID不能为空'))
  }
  return instance.post(`/comments/reply/${commentId}`, data)
}

// 删除评论
export function deleteComment(commentId) {
  return instance.delete(`/comments/${commentId}`)
} 